var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelectField',_vm._g(_vm._b({attrs:{"label":"Formaciones","items":_vm.careers,"value":_vm.value},on:{"change":_vm.onChangeSelect}},'FormSelectField',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }